import { render, staticRenderFns } from "./main-dashboard.vue?vue&type=template&id=900c1aa2&scoped=true&"
import script from "./main-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./main-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./main-dashboard.scss?vue&type=style&index=0&id=900c1aa2&lang=scss&scoped=true&"
import style1 from "./main-dashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900c1aa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('900c1aa2')) {
      api.createRecord('900c1aa2', component.options)
    } else {
      api.reload('900c1aa2', component.options)
    }
    module.hot.accept("./main-dashboard.vue?vue&type=template&id=900c1aa2&scoped=true&", function () {
      api.rerender('900c1aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery/main-dashboard/main-dashboard.vue"
export default component.exports